import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { MODULE_DESCRIPTIONS, MODULE_INTRO_T } from "@/data/moduleDescriptions";

export const ModuleBanner = ({ moduleKey, className = "" }) => (
  <img
    src={`/modules/${moduleKey}.jpg`}
    alt=""
    data-testid={`module-banner-${moduleKey}`}
    className={`w-full h-52 sm:h-64 object-cover rounded-3xl mb-6 ${className}`}
  />
);

export const ModuleIntro = ({ moduleKey, lang = "fr", className = "" }) => {
  const [open, setOpen] = useState(false);
  const d = MODULE_DESCRIPTIONS[moduleKey];
  if (!d) return null;
  const L = lang === "es" ? "es" : "fr";
  const tt = MODULE_INTRO_T[L];
  return (
    <div
      className={`rounded-2xl bg-[var(--sand)] border border-[var(--border)] p-4 sm:p-5 text-left max-w-xl mx-auto ${className}`}
      data-testid={`module-intro-${moduleKey}`}
    >
      <p className="text-sm text-[var(--ink)] leading-relaxed">{d.short[L]}</p>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid={`module-intro-toggle-${moduleKey}`}
        className="mt-2 inline-flex items-center gap-1 text-sm font-medium text-[var(--gold)] hover:brightness-110 transition-all"
      >
        {open ? tt.less : tt.more}
        <ChevronDown size={16} className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul
          className="mt-3 space-y-2 list-disc pl-5 text-sm text-[var(--ink-soft)] leading-relaxed animate-fade-up"
          data-testid={`module-intro-detail-${moduleKey}`}
        >
          {d.detail[L].map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ModuleIntro;
